import { Component } from "@angular/core";
import { Router } from "@angular/router";
import { LocalStorageService } from "../../../core/local-storage.service";
import { LoginService } from "../../login/login.service";

@Component({
  selector: "app-403-error",
  templateUrl: "./403.component.html",
  styleUrls: ["./403.component.scss"],
})
export class P403Component {
  notification_token: string;
  constructor(
    private localStorageService: LocalStorageService,
    private router: Router,
    private loginService: LoginService
  ) {}

  async logOut() {   
    this.notification_token = localStorage.getItem("notification_token");
    await this.loginService
      .removePushNotificationToken(this.notification_token)
      .subscribe((res) => {
        localStorage.removeItem("notification_token");
        this.localStorageService.removeLogin();
        this.router.navigate(["login"]);
      });
  }
}
